<lib-dialog yesText="Save" [onOkay]="save" [width]="450">
  <ng-template>
    <div class="container">
      @if (visibleField === 'address') {
        <address-editor [address]="addressHelper"> </address-editor>
      }
      @if (visibleField === 'name') {
        <div class="name-row">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>First Name</mat-label>
            <input
              matInput
              forbidAngleBrackets
              type="text"
              [formControl]="profileForm.controls.firstName"
              placeholder="Required"
              id="first-name-input"
            />
            @if (profileForm.controls.firstName.hasError('required')) {
              <mat-error> First Name is required </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Middle Name</mat-label>
            <input
              matInput
              forbidAngleBrackets
              type="text"
              [formControl]="profileForm.controls.middleName"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Last Name</mat-label>
            <input
              matInput
              forbidAngleBrackets
              type="text"
              [formControl]="profileForm.controls.lastName"
              placeholder="Required"
              id="last-name-input"
            />
            @if (profileForm.controls.lastName.hasError('required')) {
              <mat-error> Last Name is required </mat-error>
            }
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            class="suffix"
          >
            <mat-label>Suffix</mat-label>
            <input
              matInput
              forbidAngleBrackets
              type="text"
              [formControl]="profileForm.controls.suffix"
            />
            @if (profileForm.controls.suffix.hasError('maxlength')) {
              <mat-error>Suffix is limited to 15 characters.</mat-error>
            }
          </mat-form-field>
        </div>
      }
      @if (visibleField === 'phoneNumber') {
        <lib-phone [formGroup]="profileForm" [isSmallLabel]="true"></lib-phone>
      }
      @if (visibleField === 'jobTitle') {
        <mat-form-field appearance="outline" floatLabel="always">
          <input
            autoFocus
            matInput
            forbidAngleBrackets
            [formControl]="profileForm.controls.jobTitle"
          />
          @if (profileForm.controls.jobTitle.hasError('notEmpty')) {
            <mat-error>
              {{ profileForm.controls.jobTitle.getError('notEmpty') }}
            </mat-error>
          }
        </mat-form-field>
      }
      @if (visibleField === 'company') {
        <mat-form-field appearance="outline" floatLabel="always">
          <input
            autoFocus
            matInput
            forbidAngleBrackets
            [formControl]="profileForm.controls.company"
          />
          @if (profileForm.controls.company.hasError('notEmpty')) {
            <mat-error>
              {{ profileForm.controls.company.getError('notEmpty') }}
            </mat-error>
          }
        </mat-form-field>
      }
      @if (visibleField === 'linkedInProfile') {
        <mat-form-field appearance="outline" floatLabel="always">
          <input
            autoFocus
            matInput
            forbidAngleBrackets
            [formControl]="profileForm.controls.linkedInProfile"
          />
          @if (
            profileForm.controls.linkedInProfile.hasError('urlPattern') &&
            profileForm.controls.linkedInProfile.touched
          ) {
            <mat-error>
              LinkedIn Profile must be a valid Url. Please make sure to include
              https:// at the beginning.
            </mat-error>
          }
        </mat-form-field>
      }
    </div>
  </ng-template>
</lib-dialog>
<!--address had error modal. correctedAddress or !correctedAddress-->
<app-address-warning-dialog
  (useAddress)="useAddress($event)"
></app-address-warning-dialog>
